'use client';

import Link from 'next/link';
import Icon from './icon';
import { BreadCrumbs } from '#/lib/types';

export default function Breadcrumbs({ items }: { items: BreadCrumbs }) {

  return (
    <nav
      className="mx-auto flex max-w-5xl border-t border-accent-brd bg-accent-bg-1 px-4 py-2 lg:px-0"
      aria-label="Breadcrumb"
    >
      <ol
        role="list"
        className="flex w-full flex-wrap space-x-1 text-sm font-normal text-accent-txt-2 sm:space-x-2"
      >
        <li className="flex" key="home">
          <Link href="/" className="hover:text-brand">
            Home
          </Link>
        </li>
        {items.map((item,index) => (
          <li key={item.name} className="flex capitalize">
            <div className="flex items-center">
              <Icon name="chevron-right" className="h-4 w-4" />
              {/* {index + 1} - {items.length} */}
              {index + 1 === items.length 
                ? <span className="flex-1 ml-1 opacity-75 md:ml-2">
                    {item.name}
                  </span>
                : <Link href={item.href.replace(/\/+$/, '')} className="ml-1 hover:text-brand md:ml-2">
                    {item.name}
                  </Link>
              }
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
